<template>
  <div class="single-card-module">
    <div class="single-card-group">
      <div class="top">
        <div class="time">{{data.ApplyTimeStr}}</div>
        <div class="tag-box">
          <svg-icon :icon-class="`state-${data.AuditStatus === '待审核' ? 'warning' : data.AuditStatus === '审核不通过' ? 'danger' : 'success'}`"></svg-icon>
          <span :style="computedStyle(data.AuditStatus)">{{data.AuditStatus}}</span>
        </div>
      </div>
      <div class="center">
        <div class="left">
          <div class="item">
            <div class="icon-tag">原</div>
            <div class="addr">{{data.OldDormitoryFullAddress}}</div>
          </div>
          <div class="item">
            <div class="icon-tag">现</div>
            <div class="addr">{{data.NewDormitoryFullAddress}}</div>
          </div>
        </div>
        <div class="right">
          <svg-icon icon-class="xiangxia" class-name="xiangxia"></svg-icon>
        </div>
      </div>
      <div class="foot">
        <div class="time">
          <template v-if="data.OrderCode">
            <van-icon name="description" size="16"></van-icon>
            <span style="margin-left: 2px">有原合同</span>
          </template>
        </div>
        <div class="btn">
          <div class="btnSpanOne">
            <router-link tag="span" replace :to="{path: '/equipment/changeDetail', query: {Id: data.Id, type: '换寝', title: '换寝详情', backUrl: 'orderMain', backQuery: JSON.stringify({type: '换寝', title: '换寝申请',backUrl: $route.query.backUrl})}}">
              详情
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'singleCardModule',
  props: {
    data: Object
  },
  data() {
    return{}
  },
  computed: {
    computedStyle(){
      return (val) => {
        if (val.length === 5) {
          return 'top:18px!important;right:-4px!important;'
        }else if (val.length === 4) {
          return 'top:17px!important;right:-1px!important;'
        }
      }
    }
  },
  methods: {}
}

</script>

<style scoped lang="less">
.single-card-module{
  position: relative;
  margin: 15px;
  .single-card-group{
    background-color: #ffffff;
    padding: 10px 15px;
    border-radius: 8px;
    position: relative;
    z-index: 2;
    width: 100%;

    .tag-box{
      position: absolute;
      width: 64px;
      height: 64px;
      z-index: 3;
      right: -8px;
      top: -8px;
      .svg-icon{
        width: 64px;
        height: 64px;
      }
      span{
        position: absolute;
        top: 14px;
        right: 4px;
        transform: rotate(45deg);
        font-size: 12px;
        color: #ffffff;
      }
    }


    .top{
      .time{
        color: #686A6E;
      }
    }

    .center{
      background-color: #E9F1F7;
      border-radius: 8px;
      padding: 10px 15px;
      margin-top: 10px;
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      .left{
        width: 100%;
        margin-right: 10px;
        .item{
          margin-bottom: 10px;
          display: flex;
          align-items: center;
          .icon-tag{
            width: 24px;
            height: 24px;
            background-color: #8F8F8F;
            text-align: center;
            line-height: 25px;
            color: #ffffff;
            border-radius: 50%;
            margin-right: 10px;
            flex-shrink: 0;
          }

          .addr{
            color: #37393B;
          }

          &:nth-child(2){
            .icon-tag{
              background-color: #6694FC;
            }
            margin-bottom: 0;
          }
        }
      }
      .right{
        width: 22px;
        flex-shrink: 0;
        .xiangxia{
          font-size: 22px;
        }
      }
    }

    .foot{
      color: #999999;
      display: flex;
      align-items: center;
      line-height: 34px;
      width: 100%;
      >div{
        width: 100%;
        &:nth-child(1){
          display: flex;
          align-items: center;
        }
        &:nth-child(2){
          flex-shrink: 0;
          width: 100px;
          .btnSpanOne{
            float: right;
            background-color:#898989;
            color: #ffffff;
            line-height: 26px;
            padding: 0 12.5px;
            border-radius: 14px;
            display: flex;
            justify-content: center;
            align-items: center;
            span{
              font-size: 12px;
            }
            >span {
              padding: 0 5px;
            }
          }
        }
      }
    }
  }
}
</style>
